function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: SUMFIELDS opcode — add two resolved values into __opcodes.sumfields.
 */

module.exports = {
  name: 'SUMFIELDS',
  description: "\nAdds two numeric fields (resolved via VARS or literals) and stores the result\ninside context.__opcodes.sumfields under a controlled key.\n",
  exampleScript: {
    op: 'SUMFIELDS',
    a: '__opcodes.checkpathhop.activation_time',
    b: '__opcodes.importfield.duration',
    into: 'expiry'
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    var left = resolveRef(context, node.a);
    var right = resolveRef(context, node.b);
    if (left === undefined || right === undefined) {
      return false;
    }
    var l = Number(left);
    var r = Number(right);
    if (!Number.isFinite(l) || !Number.isFinite(r)) {
      return false;
    }
    var key = node.into;
    if (typeof key !== 'string' || !/^[a-zA-Z0-9_]+$/.test(key)) {
      return false;
    }
    if (!context.__opcodes) {
      context.__opcodes = {};
    }
    if (!context.__opcodes.sumfields) {
      context.__opcodes.sumfields = {};
    }
    context.__opcodes.sumfields[key] = l + r;
    return true;
  }
};
function resolveRef(root, ref) {
  if (typeof ref !== 'string') {
    return ref;
  }
  var parts = ref.split('.');
  var cursor = root;
  for (var i = 0; i < parts.length; i += 1) {
    var key = parts[i];
    if (!cursor || _typeof(cursor) !== 'object' || !Object.prototype.hasOwnProperty.call(cursor, key)) {
      return ref;
    }
    cursor = cursor[key];
  }
  return cursor;
}